import * as t from './actionTypes';
import { filter } from 'lodash';

import common from '../../common';

const initialState = {
    idUser: 0,
    login: '',
    upn: '',
    displayname: '',
    email: '',
    company: '',
    idCompany: -1,
    currentYearWeek: 0,
    rights: null,
    companyIdsWhereUserHasChangeRights: [],
    counters: { delegatedTasks: 0, waitingForApprovalTasks: 0, delegatedActivityTasks:0, waitingForApprovalActivityTasks:0 }
}

export default function (state = initialState, action) {
    switch (action.type) {

        case t.STARTUP:

            let changeRights = filter(action.payload.rights, function (r) {
                return r.securableEntity_KeyName == 'Company' && r.right == common.rights.Company_MutatePerson
            });
            let intvaluess = [];
            changeRights.map(r => r.childIds).forEach(a => intvaluess.push(...a));
            action.payload.companyIdsWhereUserHasChangeRights = Array.from(new Set(intvaluess));

            return Object.assign({}, state, action.payload)
        case t.COUNTERS:
            return Object.assign({}, state, {
                counters: action.payload
            });
        default:
            return state
    }
}